/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type SolicitationsList_stateTypes$ref: FragmentReference;
declare export opaque type SolicitationsList_stateTypes$fragmentType: SolicitationsList_stateTypes$ref;
export type SolicitationsList_stateTypes = {|
  +enumValues: ?$ReadOnlyArray<{|
    +name: string,
    +description: ?string,
  |}>,
  +$refType: SolicitationsList_stateTypes$ref,
|};
export type SolicitationsList_stateTypes$data = SolicitationsList_stateTypes;
export type SolicitationsList_stateTypes$key = {
  +$data?: SolicitationsList_stateTypes$data,
  +$fragmentRefs: SolicitationsList_stateTypes$ref,
};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "SolicitationsList_stateTypes",
  "type": "__Type",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "enumValues",
      "storageKey": null,
      "args": null,
      "concreteType": "__EnumValue",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "name",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "description",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'd627a14ab445bc875f46f4d2b1c25119';
module.exports = node;
